import { RecordByPrimaryKey } from "@pdfking/templates"
import { Map, Range } from "@pdfking/tfunc"

import type { OnTop } from "#internal"

// Mirrors Python `concrete.py:811-818` — on_top ids are `off`, `tNN`
// (NN = 04..48 step 4), then `on`. The `tNN` entries select
// `MakeOnTopSortingFunction(NN)`; `on` selects unbounded; `off`
// disables sorting.
const TN_ENTRIES = Map(
  (n: number): OnTop => ({
    id: `t${n.toString().padStart(2, "0")}`,
    value: true,
    name: "OVERLAP_PAGES",
    pages: n,
  }),
  Range(4, 48, 4)
)

export const OnTopList = RecordByPrimaryKey<OnTop>([
  { id: "off", value: false, name: "SEQUENTIAL" },
  ...TN_ENTRIES,
  { id: "on", value: true, name: "OVERLAP_ALL" },
])
